import { defineMessages } from 'react-intl'

const scope = `procurify.discoverMore.listChangelogReleases.ChangelogReleaseList`

export default defineMessages({
  readMoreLink: {
    id: `${scope}.readMoreLink`,
    defaultMessage: 'Read more',
  },
  emptyStateHeader: {
    id: `${scope}.emptyStateHeader`,
    defaultMessage: `Updates aren't available right now`,
  },
  emptyStateDescription: {
    id: `${scope}.emptyStateDescription`,
    defaultMessage:
      'We could not load the latest releases. You can read them on the Procurify changelog in the meantime.',
  },
  emptyStateAction: {
    id: `${scope}.emptyStateAction`,
    defaultMessage: 'Open the changelog',
  },
  loadingLabel: {
    id: `${scope}.loadingLabel`,
    defaultMessage: 'Loading the latest updates',
  },
})
